import styled from 'styled-components';

import theme from '$/assets/theme';

const BorderBottomSpan = styled.span`
  position: relative;
  width: fit-content;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    border-bottom: 10px solid ${theme.colors.brandBlue50};
    z-index: -1;
  }
`;

export default BorderBottomSpan;
